import { IAppState } from 'reducers';

export const selectCeaseState = (state: IAppState) => state.customerRequests.cease;

export const selectCeaseList = (state: IAppState) => selectCeaseState(state)?.list ?? [];

export const selectCeaseSelected = (state: IAppState) => selectCeaseState(state)?.selected ?? null;

export const selectCeaseLastCreated = (state: IAppState) => selectCeaseState(state)?.lastCreated ?? null;

export const selectCeaseErrorMessage = (state: IAppState) => selectCeaseState(state)?.errorMessage ?? null;

export const selectCeaseGetListState = (state: IAppState) => selectCeaseState(state)?.getListState ?? null;

export const selectCeaseGetState = (state: IAppState) => selectCeaseState(state)?.getState ?? null;

export const selectCeaseCreateState = (state: IAppState) => selectCeaseState(state)?.createState ?? null;
